module.exports = {"id":"185199","name":"Sebastian Ribas","rating":"73","photo":"./data/images/photos/2/185199.png","club":{"name":"CA Patronato","logo":"./data/images/clubs/CAPatronato.png"},"positions":["BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SebastianRibas0.json
// module id = 3868
// module chunks = 0